
<template>
  <div class="content companycontent" ref="tableBox" id="companyTable ">
    <div class="companyInfo">
      <div class="showTree">
        <el-tree
          :data="data"
          :props="defaultProps"
          node-key="id"
          :default-expanded-keys="idArr"
          :default-checked-keys="idArr"
          @node-click="handleNodeClick"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          ref="tree"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span :class="rootActive == node.key ? 'treeSelect' : ''">{{
              node.label
            }}</span>
          </span>
        </el-tree>
      </div>

      <div class="treeDetail">
        <div class="companyIcon">
          <i class="lt"></i>
          <i class="rt"></i>
          <div>
            <i class="iconfont iconcheck"></i>
            <i class="border"></i> 部门管理
          </div>
          <button
            class="rootBtn"
            @click="addOpsUser"
            id="addAreaBtn"
            v-show="addFlag"
          >
            新增根区域
          </button>
        </div>

        <div class="formtab" v-loading="loading" v-show="showForm">
          <add-dialog
            ref="menuBar"
            :roothide="roothide"
            :areaArr="areaArr"
            :confirmShow="confirmShow"
          ></add-dialog>
        </div>
        <div
          class="showMore"
          v-show="!showForm"
          style="
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #b5b5b5;
          "
        >
          请点击左侧菜单！
        </div>
      </div>
      <!-- treeDetail -->
    </div>
    <!-- </el-tab-pane> -->
    <!-- </el-tabs> -->
  </div>
</template>

<script>
import Qs from "qs";
export default {
  components: {
    addDialog: () => import("./addDialog"),
    // displays: () => import("../../../../builds/displayb")
  },
  data() {
    return {
      imgUrl: "",
      // regionId:"",
      tabName: "jsgl",
      data: [],
      showForm: false,
      roothide: false,
      id: 0,
      isAddArea: false,
      //preRemove预删除
      oPreRemove_node: {},
      oPreRemove_data: {},
      bShowNextLevelBtn: true,
      ShowNextLevelBtn: true,
      loading: true,
      showMap: true,
      showPicture: false,
      confirmShow: false,
      defaultProps: {
        children: "children",
        label: "name",
      },
      rootActive: 0,
      areaArr: [],
      addFlag: false,
      idArr: [],
    };
  },

  computed: {
    checkedTree() {},
  },

  created() {
    this.getTree();
    this.getGroup();
  },
  mounted() {},

  methods: {
    // 新增根区域
    addOpsUser() {
      this.showForm = true;
      this.roothide = false;
      this.loading = false;
      this.$refs.menuBar.addnew();
    },
    otherconfirm() {
      // 判断isAddArea如果为true时增加表单信息
      if (this.isAddArea == true) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
          } else {
            return false;
          }
        });

        // 判断isAddArea为false时修改表单信息
      } else {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
          } else {
            return false;
          }
        });
      }
    },
    filterNode(value, data, node) {
      return value.some((id) => id == data.id);
    },
    getTree() {
      //console.log(999);
      this.$axiosget("operation/deptApi/getDeptList").then((res) => {
        this.data = res.data.data;
        this.addFlag = !this.data.length;
        this.confirmShow = false;
      });
    },
    getGroup(data) {
      this.$axiosget("operation/area/queryAll?ignoreCache=true").then((res) => {
        this.areaArr = res.data.data;
      });
    },
    handleNodeClick(data, node, self = {}) {
      if (!data.id) {
        this.showForm = false;
        return;
      }
      var that = this;
      that.loading = false;
      this.showForm = true;
      this.roothide = true;
      this.confirmShow = true;
      this.$refs.menuBar.detail(data);
      this.rootActive = data.id;
    },
  },
};
</script>

<style scoped lang="less">
.companyInfo .showTree .el-tree {
  ::-webkit-scrollbar {
    width: 0;
  }
}
.box {
  height: 100%;
}
.companycontent {
  height: calc(100% - 80px);
}
.showMore {
  width: 100%;
  display: flex;
  height: calc(100% - 80px);
}
#addAreaBtn {
  width: auto !important;
  padding: 0 10px;
}
.breadcrumb {
  margin-top: 0;
}
.interval {
  height: 10px;
  background-color: #edf0f5;
}
// #companyTable {
.companyIcon {
  height: 52px;
  line-height: 52px;
  margin-bottom: 23px;
  position: relative;
  border-top: 1px solid #2d374d;
  border-bottom: 1px solid rgba(53, 135, 199, 0.5);
  .lt {
    position: absolute;
    left: 0;
    width: 18px;
    height: 1px;
    background: #35b9f7;
    z-index: 3;
  }
  .rt {
    position: absolute;
    right: 0;
    width: 18px;
    height: 1px;
    background: #35b9f7;
    z-index: 3;
  }
  .rootBtn {
    float: right;
    width: 125px;
    height: 34px;
    line-height: 34px;
    background: #e48e49;
    color: white;
    margin: 10px 32px 0 0;
  }
  > div {
    display: inline-block;
    background: #253253;
    color: #fff;
    width: 115px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    .iconcheck {
      color: #35b9f7;
    }
    .border {
      background: linear-gradient(to right, #35bfff, #8553e7);
      width: inherit;
      height: 2px;
      position: absolute;
      bottom: -1px;
      left: 0;
    }
  }
}
.companyInfo {
  background-color: #0e0e18;
  display: flex;
  height: 100%;
  .showTree {
    width: 260px;
    height: 100%;
    overflow: hidden;
    background-color: #181c2e;
    margin-right: 20px;
    .el-tree-node:focus > .el-tree-node__content,
    .el-tree-node__content:hover,
    .el-tree > .el-tree-node > .el-tree-node__content,
    .is-current {
      background: transparent;
    }

    .el-tree-node:focus > .el-tree-node__content .el-tree-node__label,
    .el-tree-node__content:hover .el-tree-node__label,
    .el-tree > .el-tree-node > .el-tree-node__content .el-tree-node__label,
    .is-current > .el-tree-node__content .el-tree-node__label {
      background: #212740;
      transition: all 0.5s;
    }

    .el-tree {
      height: 100%;
      color: #b4b4b4;
      background: rgba(0, 0, 0, 0.2);
      overflow: auto;
      > .el-tree-node > .el-tree-node__content {
        height: 40px;
        width: 260px;
        background-color: #212740;
        margin: 0;
      }
      > .el-tree-node > .el-tree-node__content > .el-tree-node__expand-icon {
        margin-left: 25px;
        margin-top: 9px;
      }
      .el-tree-node__expand-icon {
        margin-left: 25px;
        margin-top: 5px;
        font-size: 14px;
        float: left;
        padding: 5px;
      }
      > .el-tree-node > .el-tree-node__content > .custom-tree-node {
        height: 40px;
        line-height: 40px;
      }
      .el-tree-node__content {
        height: 34px;
        margin: 2px 0;
        display: block;
        padding: 0;
      }

      .custom-tree-node {
        font-size: 14px;
        display: block;
        width: 100%;
        height: 34px;
        line-height: 34px;
        border-bottom: 1px solid #464958;
        color: #c3c3c3;
        display: block;
      }
    }
  }
  .formtab {
    overflow: auto;
    height: calc(100% - 92px);
    position: relative;
    > div {
      overflow: auto;
    }
  }
  // form
  .formtab,
  .rootCss {
    .OrangeSmBtn {
      width: auto;
      padding: 0 10px;
    }
    .dialog-footer {
      text-align: right;
    }
    margin-bottom: 20px;
    .el-form-item {
      .el-form-item__label {
        color: #ccc;
      }
      .el-tree-node:focus > .el-tree-node__content,
      .el-tree-node__content:hover,
      .el-tree > .el-tree-node > .el-tree-node__content,
      .is-current {
        background: transparent;
      }

      .el-tree-node:focus > .el-tree-node__content .el-tree-node__label,
      .el-tree-node__content:hover .el-tree-node__label,
      .el-tree > .el-tree-node > .el-tree-node__content .el-tree-node__label,
      .is-current > .el-tree-node__content .el-tree-node__label {
        background: #212740;
        transition: all 0.5s;
      }
      .el-tree {
        background: transparent;
        color: #cacaca;
        border: 1px solid #3d4963;
      }
      .el-tree:hover {
        border: 1px solid #409eff;
      }
      .el-input {
        .el-input__inner {
          background: transparent;
          color: #cacaca;
          border: 1px solid #3d4963;
        }
        .el-input__inner:focus {
          outline: none;
          border-color: #409eff;
        }
      }
    }
  }
  .treeDetail {
    width: calc(100% - 270px);
    overflow: hidden;
    // padding: 15px;
    // margin-left: 15px;
    position: relative;
    background-color: #181c2e;
    .el-tree {
      max-height: 360px;
      min-height: 30px;
      overflow: auto;
      padding: 5px 0 15px 0;
    }
  }
}
.group {
  margin-bottom: 10px;
}
.formtab {
  padding: 0 100px 0 20px;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #4ea5ef;
  background: #4ea5ef;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #4ea5ef;
}
.treeSelect {
  color: #35b9f7;
}
// }
</style>
<style scope lang="less">
// .el-checkbox__inner:hover {
//   border-color: #2e3657;
// }
// .el-checkbox__input.is-focus .el-checkbox__inner {
//   border-color: #4ea5ef;
// }
// .el-pagination.is-background .el-pager li:not(.disabled).active {
//   background-color: #4ea5ef;
// }
// .el-checkbox__input.is-checked .el-checkbox__inner,
// .el-checkbox__input.is-indeterminate .el-checkbox__inner {
//   background-color: #4ea5ef;
//   border-color: #4ea5ef;
// }
// .el-radio__input.is-checked .el-radio__inner {
//   border-color: #4ea5ef;
//   background: #4ea5ef;
// }
// .el-radio__input.is-checked + .el-radio__label {
//   color: #4ea5ef;
// }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/basic/department/index.vue